
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },
        {
  hid: 'description',
  name: 'description',
  content: 'Celebrate your journey into motherhood with a beautiful maternity photoshoot in Goa. Capture stunning moments against scenic beaches and vibrant streets.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover the perfect locations in Goa for a memorable maternity photoshoot. From stunning beaches to charming streets, capture this special time in beautiful surroundings.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Celebrate your pregnancy with a beautiful maternity photoshoot in Goa. Capture precious moments against the backdrop of Goa’s stunning scenery.',
},

        {
          hid: 'keywords',
          name: 'keywords',
          content: 'maternity photoshoot, maternity photoshoot in goa, maternity photoshoot in goa price, maternity photoshoot poses, single maternity photoshoot poses, couple maternity photoshoot poses, maternity photoshoot dresses, maternity photoshoot props',
        },
       
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Stunning Locations",
      text: "Capture breathtaking views and hidden gems with the best photography spots in Goa!",
    },
    {
      title: "Perfect for Everyone",
      text: "Whether you're a pro or just starting, there's something for every photography lover!",
    },
    {
      title: "Local Experts",
      text: "Our experienced photographers guide you to the best locations and give helpful tips.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect photography experience easily through the Goa App at great rates!",
    },
  ],

    
      title: 'Maternity Photoshoot in Goa - Maternity Photoshoot Poses, Dresses and ideas',
    };
  },


  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A11%3A03.429Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QsVeawMBhdTwHOWMVBber8qog58XgG%2F7pcrBP4jEKbPbBLu%2FedgnQGivJB%2BD57plO5kSLzAC44x%2FuL%2FLZ91%2F4z33cgUyGNp1QN1C5z7BkO3ceLA%2FygnWeVkCo5jZ6qPvk24drQSjNUUMvgmaSQMhY9x9MExwZEr%2ByG6lLjIQUUhyKxjOXuLHhXkvMLDrohLURhhhpLgz25JkgJGUtGTsk12bEWXxs4sqqRyuIgjsBM9woFPfL0ZHaHDDdftdC5sSw7J6ksvwQQAQ8X6L0W24o3JYS4wp97HQueB5vMf5KApJR3CGcKm54kI8iVeBome%2F4VR5Fe43anWVjPOb%2FtJiBA%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A11%3A03.429Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QsVeawMBhdTwHOWMVBber8qog58XgG%2F7pcrBP4jEKbPbBLu%2FedgnQGivJB%2BD57plO5kSLzAC44x%2FuL%2FLZ91%2F4z33cgUyGNp1QN1C5z7BkO3ceLA%2FygnWeVkCo5jZ6qPvk24drQSjNUUMvgmaSQMhY9x9MExwZEr%2ByG6lLjIQUUhyKxjOXuLHhXkvMLDrohLURhhhpLgz25JkgJGUtGTsk12bEWXxs4sqqRyuIgjsBM9woFPfL0ZHaHDDdftdC5sSw7J6ksvwQQAQ8X6L0W24o3JYS4wp97HQueB5vMf5KApJR3CGcKm54kI8iVeBome%2F4VR5Fe43anWVjPOb%2FtJiBA%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A11%3A03.429Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QsVeawMBhdTwHOWMVBber8qog58XgG%2F7pcrBP4jEKbPbBLu%2FedgnQGivJB%2BD57plO5kSLzAC44x%2FuL%2FLZ91%2F4z33cgUyGNp1QN1C5z7BkO3ceLA%2FygnWeVkCo5jZ6qPvk24drQSjNUUMvgmaSQMhY9x9MExwZEr%2ByG6lLjIQUUhyKxjOXuLHhXkvMLDrohLURhhhpLgz25JkgJGUtGTsk12bEWXxs4sqqRyuIgjsBM9woFPfL0ZHaHDDdftdC5sSw7J6ksvwQQAQ8X6L0W24o3JYS4wp97HQueB5vMf5KApJR3CGcKm54kI8iVeBome%2F4VR5Fe43anWVjPOb%2FtJiBA%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/maternity-photoshoot-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/maternity-photoshoot-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A11%3A03.429Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QsVeawMBhdTwHOWMVBber8qog58XgG%2F7pcrBP4jEKbPbBLu%2FedgnQGivJB%2BD57plO5kSLzAC44x%2FuL%2FLZ91%2F4z33cgUyGNp1QN1C5z7BkO3ceLA%2FygnWeVkCo5jZ6qPvk24drQSjNUUMvgmaSQMhY9x9MExwZEr%2ByG6lLjIQUUhyKxjOXuLHhXkvMLDrohLURhhhpLgz25JkgJGUtGTsk12bEWXxs4sqqRyuIgjsBM9woFPfL0ZHaHDDdftdC5sSw7J6ksvwQQAQ8X6L0W24o3JYS4wp97HQueB5vMf5KApJR3CGcKm54kI8iVeBome%2F4VR5Fe43anWVjPOb%2FtJiBA%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A11%3A03.429Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QsVeawMBhdTwHOWMVBber8qog58XgG%2F7pcrBP4jEKbPbBLu%2FedgnQGivJB%2BD57plO5kSLzAC44x%2FuL%2FLZ91%2F4z33cgUyGNp1QN1C5z7BkO3ceLA%2FygnWeVkCo5jZ6qPvk24drQSjNUUMvgmaSQMhY9x9MExwZEr%2ByG6lLjIQUUhyKxjOXuLHhXkvMLDrohLURhhhpLgz25JkgJGUtGTsk12bEWXxs4sqqRyuIgjsBM9woFPfL0ZHaHDDdftdC5sSw7J6ksvwQQAQ8X6L0W24o3JYS4wp97HQueB5vMf5KApJR3CGcKm54kI8iVeBome%2F4VR5Fe43anWVjPOb%2FtJiBA%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/maternity-photoshoot-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Maternity Photoshoot - Book @ ₹4999 Flat 17% Off",
  "description": "Enjoy the best maternity shoot in Goa with stunning landscapes, vibrant culture, and unique moments captured for an unforgettable visual journey..",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A11%3A03.429Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QsVeawMBhdTwHOWMVBber8qog58XgG%2F7pcrBP4jEKbPbBLu%2FedgnQGivJB%2BD57plO5kSLzAC44x%2FuL%2FLZ91%2F4z33cgUyGNp1QN1C5z7BkO3ceLA%2FygnWeVkCo5jZ6qPvk24drQSjNUUMvgmaSQMhY9x9MExwZEr%2ByG6lLjIQUUhyKxjOXuLHhXkvMLDrohLURhhhpLgz25JkgJGUtGTsk12bEWXxs4sqqRyuIgjsBM9woFPfL0ZHaHDDdftdC5sSw7J6ksvwQQAQ8X6L0W24o3JYS4wp97HQueB5vMf5KApJR3CGcKm54kI8iVeBome%2F4VR5Fe43anWVjPOb%2FtJiBA%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "4999",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/maternity-photoshoot-goa",
        "url": "https://www.goa.app/maternity-photoshoot-goa",
        "name": "Maternity Photoshoot in Goa",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A11%3A03.429Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QsVeawMBhdTwHOWMVBber8qog58XgG%2F7pcrBP4jEKbPbBLu%2FedgnQGivJB%2BD57plO5kSLzAC44x%2FuL%2FLZ91%2F4z33cgUyGNp1QN1C5z7BkO3ceLA%2FygnWeVkCo5jZ6qPvk24drQSjNUUMvgmaSQMhY9x9MExwZEr%2ByG6lLjIQUUhyKxjOXuLHhXkvMLDrohLURhhhpLgz25JkgJGUtGTsk12bEWXxs4sqqRyuIgjsBM9woFPfL0ZHaHDDdftdC5sSw7J6ksvwQQAQ8X6L0W24o3JYS4wp97HQueB5vMf5KApJR3CGcKm54kI8iVeBome%2F4VR5Fe43anWVjPOb%2FtJiBA%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A11%3A03.429Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QsVeawMBhdTwHOWMVBber8qog58XgG%2F7pcrBP4jEKbPbBLu%2FedgnQGivJB%2BD57plO5kSLzAC44x%2FuL%2FLZ91%2F4z33cgUyGNp1QN1C5z7BkO3ceLA%2FygnWeVkCo5jZ6qPvk24drQSjNUUMvgmaSQMhY9x9MExwZEr%2ByG6lLjIQUUhyKxjOXuLHhXkvMLDrohLURhhhpLgz25JkgJGUtGTsk12bEWXxs4sqqRyuIgjsBM9woFPfL0ZHaHDDdftdC5sSw7J6ksvwQQAQ8X6L0W24o3JYS4wp97HQueB5vMf5KApJR3CGcKm54kI8iVeBome%2F4VR5Fe43anWVjPOb%2FtJiBA%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A11%3A03.429Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QsVeawMBhdTwHOWMVBber8qog58XgG%2F7pcrBP4jEKbPbBLu%2FedgnQGivJB%2BD57plO5kSLzAC44x%2FuL%2FLZ91%2F4z33cgUyGNp1QN1C5z7BkO3ceLA%2FygnWeVkCo5jZ6qPvk24drQSjNUUMvgmaSQMhY9x9MExwZEr%2ByG6lLjIQUUhyKxjOXuLHhXkvMLDrohLURhhhpLgz25JkgJGUtGTsk12bEWXxs4sqqRyuIgjsBM9woFPfL0ZHaHDDdftdC5sSw7J6ksvwQQAQ8X6L0W24o3JYS4wp97HQueB5vMf5KApJR3CGcKm54kI8iVeBome%2F4VR5Fe43anWVjPOb%2FtJiBA%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "Maternity Photo Shoot in Goa captures the stunning beaches, vibrant culture, and scenic landscapes. It’s an ideal destination for photography enthusiasts looking to frame beautiful sunsets, historic sites, and lush greenery.",
        "breadcrumb": {
            "@id": "https://www.goa.app/maternity-photoshoot-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/maternity-photoshoot-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
    "@type": "Question",
    "name": "What are the best locations for a maternity photoshoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Some of the best locations for maternity photoshoots in Goa include the serene beaches of Candolim and Vagator, the scenic Aguada Fort, and lush backdrops like Dudhsagar Falls."
    }
  },
  {
    "@type": "Question",
    "name": "What types of maternity photoshoot packages are available in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Goa offers various maternity photoshoot packages, including beachside sessions, sunset shoots, and themed maternity photography tailored to expecting mothers."
    }
  },
  {
    "@type": "Question",
    "name": "How much does a maternity photoshoot cost in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Maternity photoshoot sessions in Goa typically start from ₹4,999, depending on the location, photographer, and package you choose."
    }
  },
  {
    "@type": "Question",
    "name": "Can I book a photographer for a maternity event in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, many photographers in Goa offer customizable maternity packages, which can include baby showers or pre-birth celebrations."
    }
  },
  {
    "@type": "Question",
    "name": "What is the best time for a maternity photoshoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The best time for a maternity photoshoot in Goa is during the golden hours—shortly after sunrise or before sunset—for beautiful, natural lighting."
    }
  },
  {
    "@type": "Question",
    "name": "Are there any restrictions on maternity photoshoots at certain locations?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, some locations in Goa may have restrictions on photography, especially private properties or during certain events. Always check ahead of time."
    }
  },
  {
    "@type": "Question",
    "name": "Do maternity photoshoot packages include editing services?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Most maternity photoshoot packages in Goa include basic editing services, with additional retouching available upon request for an extra fee."
    }
  },
  {
    "@type": "Question",
    "name": "Can I choose the location for my maternity photoshoot?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, photographers in Goa are flexible and can help you choose a location that best reflects your style and vision for the maternity shoot."
    }
  },
  {
    "@type": "Question",
    "name": "What should I wear for a maternity photoshoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "For a maternity shoot in Goa, it's recommended to wear flowing dresses or comfortable, form-fitting outfits that highlight your baby bump, while complementing the beach or natural setting."
    }
  },
  {
    "@type": "Question",
    "name": "How do I book a maternity photoshoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "You can easily book a maternity photoshoot in Goa through various platforms, such as the Goa App, which provides options for photographers and package details."
    }
  }
        ]
      }
    ]
  };
},


};



  